// src/components/ui/Badge.jsx
// Использование:
//   <Badge>Заявка на консультацию</Badge>
//   <Badge variant="success">Активен</Badge>
//   <Badge variant="danger">Ошибка</Badge>
//   <Badge variant="warning">Ожидает подписи</Badge>
//   <Badge variant="info">Подписан орг.</Badge>
//   <Badge variant="purple">Подписан платформой</Badge>
//   <Badge variant="tab" active>Все</Badge>
//   <Badge icon={<Send size={10} />}>Отправлено</Badge>

import React from 'react';

const variants = {
  accent:  'bg-brand-accent-muted border-brand-accent-border text-red-600',
  success: 'bg-brand-success border-brand-success-border text-brand-success-text',
  danger:  'bg-brand-danger border-brand-danger-border text-brand-danger-text',
  neutral: 'bg-white/5 border-gray-200 text-gray-500',
  warning: 'bg-amber-500/10 border-amber-500/20 text-amber-400',   // добавлен: статусы «ожидает» (WAITING_ORG_SIGNATURE, SENT)
  info:    'bg-blue-500/10 border-blue-500/20 text-blue-400',       // добавлен: статус «подписан орг.» (SIGNED_BY_ORG)
  purple:  'bg-violet-500/10 border-violet-500/20 text-violet-400', // добавлен: статус «подписан платформой» (SIGNED_BY_PLATFORM)
  tab:          'bg-white border-gray-200 text-gray-400 hover:text-gray-900 hover:border-gray-300 cursor-pointer transition-all', // добавлен: кнопки-фильтры по статусу в ContractsTab/ApplicationsTab
  // Severity алертов (App.js — таблица инцидентов)
  critical:     'bg-red-500/10 border-red-500/20 text-red-500 shadow-sm',     // добавлен: severity Critical
  high:         'bg-orange-500/10 border-orange-500/20 text-orange-400',       // добавлен: severity High
  medium:       'bg-yellow-500/10 border-yellow-500/20 text-yellow-400',       // добавлен: severity Medium
  low:          'bg-red-600/10 border-red-600/20 text-red-600',                // добавлен: severity Low
  // Статусы алертов (App.js — детальная карточка и таблица)
  in_progress:  'bg-blue-500/15 border-blue-500/40 text-blue-600',            // добавлен: alert status In progress
  false_positive: 'bg-yellow-500/10 border-yellow-500/20 text-yellow-400',    // добавлен: alert status False Positive
};

// Для variant="tab" поддерживаем проп active — переопределяет классы на активное состояние
const tabActive = 'bg-red-700 border-red-600 text-gray-900 cursor-pointer transition-all';

export const Badge = ({
  children,
  variant = 'accent',
  icon,
  active = false,
  className = '',
  onClick,
}) => {
  const variantClass = (variant === 'tab' && active) ? tabActive : (variants[variant] ?? variants.neutral);

  return (
    <div
      onClick={onClick}
      className={`
        inline-flex items-center gap-2
        px-3 py-1 rounded-full border
        text-label font-black uppercase tracking-widest
        ${variantClass}
        ${className}
      `}
    >
      {icon && icon}
      {children}
    </div>
  );
};